import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import SettingsIcon from '@mui/icons-material/Settings';
import { Stack, Button, Box, IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Drawer, List, ListItem, ListItemButton, Divider, Typography } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/auth';
import { hasPermission, CONTEXTS, SCOPES } from '../../services/permissions';

import { TheNavBarTabs } from './TheNavBarTabs';
import "../AboutUs/Home/Home.css";

export const TheNavBar = ({ pathname, setFontSize }) => {
  const { authenticated, logout, role } = useContext(AuthContext);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [avatarAnchor, setAvatarAnchor] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isMobile = useMediaQuery('(max-width:768px)');

  const multipleScopes = [SCOPES.canView, SCOPES.canCreate, SCOPES.canEdit, SCOPES.canDelete];
  const navItems = [
    hasPermission(role, CONTEXTS.art, SCOPES.canView) && { label: 'Obras', to: '/arts/search' },
    hasPermission(role, CONTEXTS.font, multipleScopes) && { label: 'Fichas Catalográficas', to: '/fonts' },
    hasPermission(role, CONTEXTS.user, multipleScopes) && { label: 'Usuários', to: '/users' },
    hasPermission(role, CONTEXTS.report, SCOPES.canView) && { label: 'Relatórios', to: '/reports' },
    hasPermission(role, CONTEXTS.siteContent, SCOPES.canView) && { label: 'Editar Site', to: '/site-content' },
  ].filter(Boolean);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = () => {
    setOpen(false);
    logout();
  };

  const navBtnStyle = {
    color: '#1a1a1a', 
    textTransform: 'none', 
    fontWeight: 600, 
    fontSize: '0.92em',
    padding: '6px 18px',
    borderRadius: '6px',
    transition: 'background 0.15s',
    '&:hover': {
      background: '#5a9e98',
      color: '#fff',
    }
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <header className="home-header">
        <Link to="/" className="home-header-logo-link">
          <div className="home-header-left">
            <img
             src={`${process.env.PUBLIC_URL}/logo_oficial.png`}
             alt="Logo CEDOMCA"
             className="home-logo-img"
            />
            <div className="home-logo-text">
              <span className="home-logo-title">CEDOMCA</span>
              <span className="home-logo-subtitle">
                Centro de Documentação e Memória da Cultura na Amazônia
              </span>
            </div>
          </div>
        </Link>
      </header>

      {authenticated ? (
        <nav className="home-nav">
          {isMobile ? (
            <>
              <IconButton
                onClick={() => setDrawerOpen(true)}
                sx={{ ml: 'auto', background: '#fff', borderRadius: '6px', padding: '6px 10px', '&:hover': { background: '#e8f5f3' } }}
                aria-label="Abrir menu"
              >
                <MenuIcon sx={{ color: '#4a9e8e' }} />
              </IconButton>

              <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
                <Box sx={{ width: 260, pt: 3, pb: 2, display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <Typography variant="subtitle2" sx={{ px: 2, pb: 1, color: '#888', fontWeight: 600, textTransform: 'uppercase', fontSize: '0.72em', letterSpacing: 1 }}>
                    Menu
                  </Typography>
                  <List disablePadding>
                    {navItems.map(item => (
                      <ListItem key={item.to} disablePadding>
                        <ListItemButton
                          component={Link}
                          to={item.to}
                          onClick={() => setDrawerOpen(false)}
                          selected={pathname.startsWith(item.to)}
                          sx={{
                            px: 2, py: 1.2,
                            '&.Mui-selected': { background: '#e8f5f3', color: '#4a9e8e', fontWeight: 600 },
                            '&:hover': { background: '#f0faf8' },
                          }}
                        >
                          <ListItemText primary={item.label} primaryTypographyProps={{ fontSize: '0.95em' }} />
                        </ListItemButton>
                      </ListItem>
                    ))}
                  </List>

                  <Divider sx={{ my: 2 }} />

                  <Typography variant="subtitle2" sx={{ px: 2, pb: 1, color: '#888', fontWeight: 600, textTransform: 'uppercase', fontSize: '0.72em', letterSpacing: 1 }}>
                    Tamanho do texto
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 1, px: 2, pb: 2 }}>
                    <Button size="small" variant="outlined" onClick={() => setFontSize(s => Math.max(12, s - 2))} sx={{ minWidth: 40 }}>A-</Button>
                    <Button size="small" variant="outlined" onClick={() => setFontSize(16)} sx={{ minWidth: 40 }}>A</Button>
                    <Button size="small" variant="outlined" onClick={() => setFontSize(s => Math.min(24, s + 2))} sx={{ minWidth: 40 }}>A+</Button>
                  </Box>

                  <Divider sx={{ mb: 2 }} />

                  <Box sx={{ px: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Button
                      fullWidth
                      startIcon={<SettingsIcon />}
                      onClick={() => { setDrawerOpen(false); navigate('/profile'); }}
                      sx={{ justifyContent: 'flex-start', textTransform: 'none', color: '#4a9e8e' }}
                    >
                      Alterar Perfil
                    </Button>
                    <Button
                      fullWidth
                      startIcon={<LogoutIcon />}
                      onClick={() => { setDrawerOpen(false); handleClickOpen(); }}
                      sx={{ justifyContent: 'flex-start', textTransform: 'none', color: '#d32f2f' }}
                    >
                      Sair
                    </Button>
                  </Box>
                </Box>
              </Drawer>
            </>
          ) : (
            <>
              <TheNavBarTabs pathname={pathname} />
              <Stack direction="row" spacing={1} sx={{ ml: 'auto' }}>
                <div style={{ background: '#fff', borderRadius: '6px', padding: '2px 4px', display: 'flex', alignItems: 'center', gap: '2px' }}>
                  <Button size="small" sx={{ ...navBtnStyle, minWidth: 32, padding: '4px 8px' }} onClick={() => setFontSize(s => Math.max(12, s - 2))}>A-</Button>
                  <Button size="small" sx={{ ...navBtnStyle, minWidth: 32, padding: '4px 8px' }} onClick={() => setFontSize(16)}>A</Button>
                  <Button size="small" sx={{ ...navBtnStyle, minWidth: 32, padding: '4px 8px' }} onClick={() => setFontSize(s => Math.min(24, s + 2))}>A+</Button>
                </div>
                <IconButton
                  onClick={(e) => setAvatarAnchor(e.currentTarget)}
                  sx={{ background: '#fff', borderRadius: '6px', padding: '4px 8px', '&:hover': { background: '#e8f5f3' } }}
                >
                  <AccountCircleIcon sx={{ color: '#4a9e8e', fontSize: '1.6rem' }} />
                </IconButton>
                <Menu
                  anchorEl={avatarAnchor}
                  open={Boolean(avatarAnchor)}
                  onClose={() => setAvatarAnchor(null)}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  PaperProps={{
                    sx: {
                      mt: 0.5,
                      borderRadius: '8px',
                      boxShadow: '0 4px 16px rgba(0,0,0,0.10)',
                      minWidth: 180,
                    }
                  }}
                >
                  <MenuItem
                    onClick={() => { setAvatarAnchor(null); navigate('/profile'); }}
                    sx={{ padding: '12px 12px', gap: 1.5 }}
                  >
                    <ListItemIcon sx={{ minWidth: 'unset' }}>
                      <SettingsIcon sx={{ color: '#4a9e8e' }} />
                    </ListItemIcon>
                    <ListItemText primary="Alterar Perfil" />
                  </MenuItem>
                </Menu>
                <Button
                  onClick={handleClickOpen}
                  startIcon={<LogoutIcon />}
                  sx={{ ...navBtnStyle, color: '#fff', background: '#d32f2f', '&:hover': { background: '#b71c1c', color: '#fff' } }}
                >
                  Sair
                </Button>
              </Stack>
            </>
          )}
        </nav>
      ) : null}

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Sair"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Você tem certeza que deseja sair?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button onClick={handleLogout}>OK</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
